import React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { LoaderWithOverlay, Button, BUTTON_LAYOUTS, Scrollbar } from 'components/UI'
// view components
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
import Resource from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities/components/ResourceActivity'
// constants
import { Modals } from 'constants/modals'
// context
import { ResourcesListAPIContext } from 'containers/Activities/layers/API/ResourcesList'
import { ResourcesListBLContext } from 'containers/Activities/layers/BL/ResourcesList'

// styled
const AddResourceButton = styled(Button)`
  margin-bottom: 16px;
`

export const Wrapper = styled(Scrollbar)`
  padding: 16px 32px 16px 16px;
`

const ResourcesList = () => {
  // context
  const { canCreate, fields, resources, loading } = React.useContext(ResourcesListAPIContext)
  const { handleCreateResource } = React.useContext(ResourcesListBLContext)

  return loading ? (
    <LoaderWithOverlay isLoading={loading} />
  ) : (
    <Wrapper>
      {canCreate && (
        <Grid container alignItems={'center'} justifyContent={'flex-end'}>
          <AddResourceButton layout={BUTTON_LAYOUTS.PURPLE} onClick={handleCreateResource}>
            Create Resource
          </AddResourceButton>
        </Grid>
      )}

      {resources.map((item) => {
        return item.map((component) => {
          if (Array.isArray(component)) {
            return component.map((resource) => {
              return <Resource key={resource.id} resource={resource} fields={fields} />
            })
          }
        })
      })}

      <ConfirmDeleteModal modalType={Modals.CONFIRM_DELETE_ACTIVITY_MODAL} header={`Delete Resource`}>
        Are you sure you want to delete this resource?
      </ConfirmDeleteModal>
    </Wrapper>
  )
}

export default ResourcesList
